import { render, staticRenderFns } from "./addProduce.vue?vue&type=template&id=35055345&scoped=true"
import script from "./addProduce.vue?vue&type=script&lang=js"
export * from "./addProduce.vue?vue&type=script&lang=js"
import style0 from "./addProduce.vue?vue&type=style&index=0&id=35055345&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35055345",
  null
  
)

export default component.exports